window.algoliaCustomSearchMainTemplate = function(data, html) {
  const isAdvancedProductListings = document.querySelector('.advanced-product-listings') !== null;
  const hasAdvancedListingTable = document.querySelectorAll('.advanced-listing-table').length > 0;
  return html`
    <div class="ais-page ${hasAdvancedListingTable ? 'ais-page--with-advanced-listing' : ''}">
      <div class="ais-input" style="display: none">
        <div class="ais-search-box-container"></div>
        <div class="ais-input-button">
          <div class="ais-clear-input-icon"></div>
        </div>
      </div>
      <div class="ais-facets-button">
      </div>
      ${hasAdvancedListingTable ? html`
        <div class="ais-facets-and-block-wrapper">
          <div class="ais-facets">
            <div class="mobile-facets-header">
              <div class="title">
                Filter and Sort
                <div class="counter"></div>
              </div>
              <div class="mobile-close-facets">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.61315 15.5549L0.346191 14.4014L7.07924 8.27118L0.346191 2.14095L1.61315 0.987427L8.34619 7.11766L15.0792 0.987427L16.3462 2.14095L9.61315 8.27118L16.3462 14.4014L15.0792 15.5549L8.34619 9.4247L1.61315 15.5549Z" fill="#19242E"/>
                </svg>
              </div>
            </div>
            <div class="mobile-sort-wrapper"></div>
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet, index) =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} ${index === 0 ? 'first-facet' : ''}"
                  >
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                    >
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                  <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                  ></span>
                <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                    ${algoliaShopify.translations.sortBy}:
                    <span class="ais-sort-orders-container"></span>
                  `
                  : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block ${isAdvancedProductListings ? 'advanced-ais-listings' : ''}">
            </div>
          </div>
        </div>
      ` : html`
        <div class="ais-facets">
          <div class="mobile-facets-header">
            <div class="title">
              Filter and Sort
              <div class="counter"></div>
            </div>
            <div class="mobile-close-facets">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.61315 15.5549L0.346191 14.4014L7.07924 8.27118L0.346191 2.14095L1.61315 0.987427L8.34619 7.11766L15.0792 0.987427L16.3462 2.14095L9.61315 8.27118L16.3462 14.4014L15.0792 15.5549L8.34619 9.4247L1.61315 15.5549Z" fill="#19242E"/>
              </svg>
            </div>
          </div>
          <div class="mobile-sort-wrapper"></div>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            (facet, index) =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} ${index === 0 ? 'first-facet' : ''}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                  >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
                ></span>
              <span class="ais-change-display-list"
              ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                  ${algoliaShopify.translations.sortBy}:
                  <span class="ais-sort-orders-container"></span>
                `
                : html`
                  ${algoliaShopify.translations.sortBy}
                  ${algoliaShopify.translations.relevance}
                `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block ${isAdvancedProductListings ? 'advanced-ais-listings' : ''}">
          </div>
        </div>
      `}
      <div class="ais-pagination-container"></div>
    </div>
  `;
};
